{
  "name": "siglar-reporting-form",
  "version": "2.7.11",
  "private": true,
  "scripts": {
    "postversion": "node scripts/update-build-details.cjs",
    "build": "npm run postversion && ng build",
    "build:prod": "npm run postversion && ng build --configuration production",
    "build:source-map": "ng build --configuration production --source-map",
    "ci:clean": "node scripts/clean-build.cjs",
    "cleanup:report": "knip --no-progress --reporter json",
    "cleanup:check": "node tools/cleanup-check.cjs",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "e2e": "ng e2e",
    "bundle-report": "ng build --configuration production --source-map && source-map-explorer www/*.js",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "ng": "ng",
    "serve-dist": "http-server -p 8080 -c-1 www",
    "start": "ng serve",
    "test": "ng test",
    "test:component": "cypress run --component --browser electron",
    "test:lifecycle": "tsc --noEmit --project cypress/tsconfig.json && ng run app:cypress-run --watch=false --headless=true --browser=electron --spec=cypress/e2e/report-lifecycle.cy.ts,cypress/e2e/stale-retry.cy.ts",
    "test:ci": "ng test --no-watch --no-progress --browsers=ChromeHeadlessCI --reporters=coverage --code-coverage",
    "watch": "ng build --watch"
  },
  "dependencies": {
    "@angular/animations": "^19.2.7",
    "@angular/cdk": "^19.2.0",
    "@angular/common": "^19.2.7",
    "@angular/compiler": "^19.2.7",
    "@angular/core": "^19.2.7",
    "@angular/forms": "^19.2.7",
    "@angular/material": "^19.2.0",
    "@angular/platform-browser": "^19.2.7",
    "@angular/platform-browser-dynamic": "^19.2.7",
    "@angular/router": "^19.2.7",
    "@angular/service-worker": "^19.2.7",
    "@fontsource/ubuntu": "^5.0.8",
    "@ngrx/effects": "^19.1.0",
    "@ngrx/operators": "^19.1.0",
    "@ngrx/router-store": "^19.1.0",
    "@ngrx/store": "^19.1.0",
    "decimal.js": "^10.5.0",
    "dompurify": "^3.2.3",
    "idb": "^8.0.3",
    "material-icons": "^1.13.12",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.0",
    "uuid": "^9.0.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.9",
    "@angular/cli": "~19.2.9",
    "@angular/compiler-cli": "^19.2.7",
    "@cypress/schematic": "2.5.2",
    "@eslint/js": "9.25.1",
    "@ngrx/eslint-plugin": "^19.1.0",
    "@ngrx/store-devtools": "^19.1.0",
    "@types/jasmine": "~5.1.0",
    "@types/uuid": "^9.0.1",
    "angular-eslint": "19.3.0",
    "cypress": "latest",
    "eslint": "^9.6.0",
    "http-server": "^14.1.1",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "knip": "6.40.0",
    "source-map-explorer": "^2.5.3",
    "typescript": "~5.8.3",
    "typescript-eslint": "8.31.0"
  }
}
